import { PipFace, VpFace, XFace } from './face'

export const PIP_1: PipFace = { type: "Pips", value: 1 };
export const PIP_2: PipFace = { type: "Pips", value: 2 };
export const PIP_3: PipFace = { type: "Pips", value: 3 };
export const PIP_4: PipFace = { type: "Pips", value: 4 };
export const PIP_5: PipFace = { type: "Pips", value: 5 };
export const PIP_6: PipFace = { type: "Pips", value: 6 };
export const VP_1: VpFace = { type: "Vp", value: 1 };
export const VP_2: VpFace = { type: "Vp", value: 2 };
export const VP_3: VpFace = { type: "Vp", value: 3 };
export const VP_4: VpFace = { type: "Vp", value: 4 };
export const VP_5: VpFace = { type: "Vp", value: 5 }
export const X: XFace = { type: "X" }